// extracted by mini-css-extract-plugin
export default {"content":"index_content__4nRAj","name":"index_name__i9kng","features":"index_features__DPeac"};